import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import type { NeedsReviewBadgeProps } from "./types";

export const NeedsReviewBadge = (_props: NeedsReviewBadgeProps) => {
  const { t } = useTranslation();

  return (
    <span
      className="inline-flex items-center gap-1 text-xs font-medium text-amber-700"
      title={t("smartSurveyor.needsReviewBadge.tooltip")}
    >
      <AlertTriangle size={12} />
      {t("smartSurveyor.needsReviewBadge.label")}
    </span>
  );
};
